var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-table',{attrs:{"fields":_vm.changes_fields,"items":_vm.changes,"show_header":false,"show_pagination_description":false},scopedSlots:_vm._u([{key:"state",fn:function(ref){
var row = ref.item;
return [_c('span',{class:{
        'text-success': row.state === 'add',
        'text-danger': row.state === 'remove'
      }},[_vm._v(" "+_vm._s(_vm.$t(("pbx.phone-list.form.state." + (row.state))))+" ")])]}},{key:"actions",fn:function(ref){
      var row = ref.item;
return [_c('table-control',{attrs:{"type":"trash"},on:{"click":function($event){return _vm.removeChange(row.id)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }